import { Image } from '@/ui'
import { mtc } from '@/styles'

const SPARKLES_SVG = 'https://heard-images.s3.amazonaws.com/assets/Sparkles.svg'

interface SparklesProps {
  className?: string
}

export const Sparkles = ({ className }: SparklesProps) => (
  <Image
    src={SPARKLES_SVG}
    alt="Sparkles decorative icon"
    width={80}
    height={80}
    loading="eager"
    className={mtc('flex-shrink-0', className)}
  />
)
